import { type ReactNode } from 'react';

import { cn } from '@/lib/utils';

import { FormError } from './FormError';

export interface FormFieldProps {
  label: string;
  htmlFor: string;
  error?: string;
  description?: string;
  required?: boolean;
  children: ReactNode;
  className?: string;
}

export const FormField = ({
  label,
  htmlFor,
  error,
  description,
  required,
  children,
  className,
}: FormFieldProps) => {
  const errorId = `${htmlFor}-error`;

  return (
    <div className={cn('flex flex-col', className)}>
      <div className="flex flex-1 flex-col justify-end space-y-2">
        <label htmlFor={htmlFor} className="text-foreground text-sm font-medium">
          {label}
          {required && <span className="text-destructive ml-1">*</span>}
        </label>
        {children}
      </div>
      <div className="mt-1 min-h-[1.5rem]">
        {description && !error && <p className="text-muted-foreground text-xs">{description}</p>}
        {error && <FormError id={errorId} message={error} />}
      </div>
    </div>
  );
};
